import { render, staticRenderFns } from "./AppCheckBox.vue?vue&type=template&id=72160822&scoped=true&"
import script from "./AppCheckBox.vue?vue&type=script&lang=js&"
export * from "./AppCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./AppCheckBox.vue?vue&type=style&index=0&id=72160822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72160822",
  null
  
)

export default component.exports